<!--
 * @Description:
 * @Author: 王赵坤
 * @Date: 2023-11-21 09:54:15
 * @LastEditors: 王赵坤
 * @LastEditTime: 2023-12-06 14:08:45
-->
<template>
  <el-dialog title="" :visible.sync="dialogVisible" width="860px" :before-close="openEdit" :close-on-click-modal="false">
    <div class="boxmessage">
      <el-descriptions class="margin-top" title="标题" :column="4">
        <el-descriptions-item label="发布人"  :span="2">超级管理员</el-descriptions-item>
        <el-descriptions-item label="发布时间"  :span="2">2023-06-25 8:25</el-descriptions-item>
        <el-descriptions-item label="内容" :span="4">江苏省苏州市吴中区吴中大道 1188 号呼啦圈未发货辣煌尚劳动法哈苏理发沙发啦手打发啦手打发啦大沙发号呼啦圈未发货辣煌尚劳动法哈苏理发沙发啦手打发啦手打发啦大沙发号呼啦圈未发货辣煌尚劳动法哈苏理发沙发啦手打发啦手打发啦大沙发号呼啦圈未发货辣煌尚劳动法哈苏理发沙发啦手打发啦手打发啦大沙发号呼啦圈未发货辣煌尚劳动法哈苏理发沙发啦手打发啦手打发啦大沙发号呼啦圈未发货辣煌尚劳动法哈苏理发沙发啦手打发啦手打发啦大沙发号呼啦圈未发货辣煌尚劳动法哈苏理发沙发啦手打发啦手打发啦大沙发号呼啦圈未发货辣煌尚劳动法哈苏理发沙发啦手打发啦手打发啦大沙发号呼啦圈未发货辣煌尚劳动法哈苏理发沙发啦手打发啦手打发啦大沙发号呼啦圈未发货辣煌尚劳动法哈苏理发沙发啦手打发啦手打发啦大沙发号呼啦圈未发货辣煌尚劳动法哈苏理发沙发啦手打发啦手打发啦大沙发号呼啦圈未发货辣煌尚劳动法哈苏理发沙发啦手打发啦手打发啦大沙发号呼啦圈未发货辣煌尚劳动法哈苏理发沙发啦手打发啦手打发啦大沙发</el-descriptions-item>
      </el-descriptions>
    </div>
    <div slot="footer" class="dialog-footer">
      <div></div>
      <div class="buttom-btn">
        <span></span>
        <div @click="openEdit()">
          确 定
        </div>
      </div>
    </div>
  </el-dialog>

</template>

<script>
export default {
  name: 'notificationsinfor',
  props: ['dialogVisiblemess', 'row'],
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        picture: '',
      },
      statusobj: {}, //点击了学生信息
      messgeinforlist: [], //信息详情
      infordata: this.$store.getters.getUserInfo, //用户信息详情
    }
  },
  watch: {
    dialogVisiblemess: function (newV, oldV) {
      this.dialogVisible = this.dialogVisiblemess
      this.getmessgeinfor()
    },
  },
  methods: {
    openEdit() {
      this.statusobj = {}
      this.$emit('lcclick')
    },
    // 消息详情
    getmessgeinfor() {
      let obj = {
        teacher_id: this.statusobj.teacher_id,
      }
      this.$http.messageinfo(obj).then((res) => {
        this.messgeinforlist = res.data
        this.scrollToBottom();
      })
    },
  },
  mounted() {},
  created() {},
}
</script>

<style lang="less" scoped>
.dialog-footer{
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
}
.buttom-btn{
  display: flex;
  width: 160px;
  justify-content: space-around;

  :nth-child(2){
    width: 70px;
    height: 35px;
    background-color: #979797;
    text-align: center;
    line-height: 35px;
    border-radius: 5px;
    background-color: #409eff;
    border-color: #409eff;
    color: #fff;
    cursor:pointer
  }
  :nth-child(2):hover{
    width: 70px;
    height: 35px;
    background-color: #979797;
    text-align: center;
    line-height: 35px;
    border-radius: 5px;
    background-color: #a0cfff;
    border-color: #409eff;
    color: #fff;
    cursor:pointer
  }
}
/deep/.el-dialog__body {
  padding: 0px 20px 20px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  /* margin-left: 88px; */
  height: 650px;
}
.box-body-left::-webkit-scrollbar {
  width: 4px;
  background-color: #b0b0b0;
}

.box-body-left:hover ::-webkit-scrollbar-track-piece {
  /*鼠标移动上去再显示滚动条*/
  background-color: #b0b0b0;
  /* 滚动条的背景颜色 */
  border-radius: 6px;
  /* 滚动条的圆角宽度 */
}

.box-body-left:hover::-webkit-scrollbar-thumb:hover {
  background-color: #c0cecc;
}

.box-body-left:hover::-webkit-scrollbar-thumb:vertical {
  background-color: #c0cedc;
  border-radius: 6px;
  outline: 2px solid #b0b0b0;
  outline-offset: -2px;
  border: 2px solid #b0b0b0;
}
.box-body-rigth-message::-webkit-scrollbar {
  width: 4px;
  background-color: #b0b0b0;
}

.box-body-rigth-message:hover ::-webkit-scrollbar-track-piece {
  /*鼠标移动上去再显示滚动条*/
  background-color: #b0b0b0;
  /* 滚动条的背景颜色 */
  border-radius: 6px;
  /* 滚动条的圆角宽度 */
}

.box-body-rigth-message:hover::-webkit-scrollbar-thumb:hover {
  background-color: #c0cecc;
}

.box-body-rigth-message:hover::-webkit-scrollbar-thumb:vertical {
  background-color: #c0cedc;
  border-radius: 6px;
  outline: 2px solid #b0b0b0;
  outline-offset: -2px;
  border: 2px solid #b0b0b0;
}
:deep .ant-select:not(.ant-select-customize-input) .ant-select-selector {
  line-height: 30px;
}
// 滚动条宽度
div::-webkit-scrollbar {
  width: 4px;
}
// 滚动条轨道
div::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 2px;
}
// 小滑块
div::-webkit-scrollbar-thumb {
  background: #f5f5f5;
  border-radius: 10px;
}
div::-webkit-scrollbar-thumb:hover {
  background: #f5f5f5;
}
.boxmessage {
  width: 820px;
  display: flex;
  justify-content: center;
  .box-body {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    .box-body-rigth {
      width: 810px;
      height: 640px;
      padding: 10px;
      background-color: #f5f5f5;
      .CommentOutlined {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .el-icon-chat-dot-square {
          font-size: 50px;
          color: #979797;
        }
      }
      // border: 1px solid #f56c6c;
      .box-body-rigth-message {
        width: 100%;
        height: 550px;
        overflow-y: auto;
        padding-right: 10px;
        padding-bottom: 10px;
        // overflow: hidden;
      }
      .box-body-rigth-bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px solid #c4c4c4;
        .box-body-rigth-bottom-text {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          width: 100%;
          .bottom-text-input {
            width: 600px;
            margin-top: 10px;
          }
          .bottom-text-btn {
            width: 100px;
            margin-top: 10px;
          }
        }
      }
      .box-body-rigth-li {
        width: 100%;
        display: flex;
        margin-top: 10px;
        img {
          width: 50px;
          height: 50px;
          border-radius: 5px;
        }
        div {
          max-width: 460px;
          word-wrap: break-word;
          position: relative;
          margin-left: 20px;
          background-color: #fff;
          border-radius: 5px;
          padding: 10px;
          color: black;
        }
        div:before {
          width: 0px;
          height: 0px;
          content: '';
          border-top: 10px solid transparent;
          border-bottom: 5px solid transparent;
          border-right: 10px solid #fff;
          position: absolute;
          top: 10px;
          left: -10px;
        }
      }
      .box-body-rigth-lileft {
        width: 100%;
        display: flex;
        flex-direction: row-reverse;
        margin-top: 10px;
        img {
          width: 50px;
          height: 50px;
          border-radius: 5px;
        }
        div {
          max-width: 460px;
          word-wrap: break-word;
          position: relative;
          margin-right: 20px;
          background-color: #e8f3fe;
          border-radius: 5px;
          padding: 10px;
        }
        div:before {
          width: 0px;
          height: 0px;
          content: '';
          border-top: 10px solid transparent;
          border-bottom: 5px solid transparent;
          border-left: 10px solid #e8f3fe;
          position: absolute;
          top: 10px;
          right: -10px;
        }
      }
    }
  }
}
.box-body-left {
  width: 260px;
  height: 640px;
  overflow-y: auto;
  // border: 1px solid #f56c6c;
  .box-body-left-li {
    padding: 5px 0 5px 0;
    background-color: #e4e4e4;
    padding: 5px;
    display: flex;
    cursor: pointer;
    img {
      width: 50px;
      height: 50px;
      border-radius: 5px;
    }
    div {
      display: flex;
      flex-direction: column;
      :nth-child(1) {
        margin-left: 10px;
        color: black;
        font-size: 14px;
      }
      :nth-child(2) {
        margin-left: 10px;
        color: #979797;
        font-size: 14px;
      }
    }
  }
  .box-body-left-li-true {
    padding: 5px 0 5px 0;
    background-color: #c5c5c5;
    padding: 5px;
    display: flex;
    cursor: pointer;
    img {
      width: 50px;
      height: 50px;
      border-radius: 5px;
    }
    div {
      display: flex;
      flex-direction: column;
      // width: 600px;
      :nth-child(1) {
        margin-left: 10px;
        color: black;
        font-size: 14px;
      }
      :nth-child(2) {
        margin-left: 10px;
        color: #979797;
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/notificationsinfor.vue